// extracted by mini-css-extract-plugin
export default {"minLength":"FieldDefinitionPanel_minLength__-SjK2","maxLength":"FieldDefinitionPanel_maxLength__8KJrb","optionItemField":"FieldDefinitionPanel_optionItemField__5YQDK"};